<template>
    <div class="invoicing position-relative has-tool-menu stock-mgmt">
        <div class="tool-menu">
            <Breadcrumb />

            <div class="buttons">
                <!--<ButtonAreas :entities="selected" />-->
            </div>
        </div>

        <b-card no-body>
            <div slot="header">
                <i class="fa fa-tags"></i> Z-reports
                <div class="card-header-actions">
                    <!-- <b-link href="#" class="card-header-action btn-setting">
                        <i class="fa fa-cog"></i>
                    </b-link> -->
                </div>
            </div>
            <DataTable ref="dataTable" url="/api/flatpay/z-reports" :fields="fields" name="z-reports" :filter="true" cache-search="z-reports">
                
                <template slot="SaleAmount" slot-scope="{props}">
                    {{props.row.SaleAmount / 100}}
                </template>

                <template slot="RefundAmount" slot-scope="{props}">
                    {{props.row.RefundAmount / 100}}
                </template>

                <template slot="CashbackAmount" slot-scope="{props}">
                    {{props.row.CashbackAmount / 100}}
                </template>

                <template slot="CreateDate" slot-scope="{props}">
                    {{$moment(props.row.CreateDate).format("DD-MM-YYYY HH:mm")}}
                </template>

                <template slot="edit" slot-scope="{props}">
                    <b-button :href="'/api/flatpay/z-reports/' + props.row.Id" target="_blank" variant="primary"><i class="fa fa-download"></i> Download</b-button>
                </template>
            </DataTable>
        </b-card>


    </div>
</template>

<script>
    export default {
        data: () => ({
            fields: [
                {
                    "name": "Date",
                    "type": "text",
                    "label": "Date",
                    "value": null,
                    "filter": false,
                    "visible": true,
                    "sort": false,
                    "class": null,
                    "values": []
                },
                {
                    "name": "TerminalId",
                    "type": "text",
                    "label": "Terminal",
                    "value": null,
                    "filter": true,
                    "visible": true,
                    "sort": false,
                    "class": null,
                    "values": []
                },
                {
                    "name": "SaleCount",
                    "type": "number",
                    "label": "Sale count",
                    "value": null,
                    "filter": false,
                    "visible": true,
                    "sort": true,
                    "class": null,
                    "values": []
                },
                {
                    "name": "SaleAmount",
                    "type": "number",
                    "label": "Sale amount",
                    "value": null,
                    "filter": false,
                    "visible": true,
                    "sort": true,
                    "class": null,
                    "values": []
                },
                {
                    "name": "RefundAmount",
                    "type": "number",
                    "label": "Refund amount",
                    "value": null,
                    "filter": false,
                    "visible": true,
                    "sort": true,
                    "class": null,
                    "values": []
                },
                {
                    "name": "CashbackAmount",
                    "type": "number",
                    "label": "Cashback amount",
                    "value": null,
                    "filter": false,
                    "visible": true,
                    "sort": true,
                    "class": null,
                    "values": []
                },
                {
                    "name": "CreateDate",
                    "type": "date",
                    "label": "Created",
                    "value": null,
                    "filter": true,
                    "visible": true,
                    "sort": false,
                    "class": null,
                    "values": null
                },
                {
                    name: "edit",
                    visible: true,
                    label: "",
                    class: "text-right",
                }
            ]
        }),
        components: {},
        computed: {

        },
        watch: {

        },
        methods: {

        },
        created() {

        },
        mounted() { }
    };
</script>

<style lang="scss">
</style>